<div id="elevaagendaedu" *ngIf="!isLoading">
  <eae-header-navigation  title="Detalhes da Fatura"></eae-header-navigation>
  <eae-fatura-detalhes [showTicket]="false" [fatura]="fatura" [faturaDetalhada]="faturaDetalhada"></eae-fatura-detalhes>
  <eae-fatura-escolha-pagamento
    [fatura]="fatura" 
    [faturaDetalhada]="faturaDetalhada"
  ></eae-fatura-escolha-pagamento>
</div>
